export const contingentInfoIcon = {
  data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 25 25"><path d="M12.781 23.781c6.075 0 11-4.925 11-11s-4.925-11-11-11-11 4.925-11 11 4.925 11 11 11zM12.781 10.581v8.067" stroke="#F39C12" stroke-width="2" stroke-miterlimit="10" stroke-linecap="square"/><path d="M12.781 7.648a1.1 1.1 0 100-2.2 1.1 1.1 0 000 2.2z" fill="#F39C12"/></svg>`,
  name: 'info',
};
